import { Accordion, AccordionSummary } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import "./style.scss"
const BirinchiIkkinchi2 = () => {
  const Oqituvchi = [
    {
      id:1,
      materialName: "o'tkan kunlar 1-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/kitoblar/01_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:2,
      materialName: "onta_negr_bolasi.",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/onta_negr_bolasi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:3,
      materialName: "orzularingiz_ogirlanishiga",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/orzularingiz_ogirlanishiga_jol_qojmang..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:4,
      materialName: "otkir_hoshimov_tushda",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/otkir_hoshimov_tushda_kechgan_umirlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:5,
      materialName: "pirimqul_qodirov_humoyun",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:6,
      materialName: "pirimqul_qodirov_humoyun",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:7,
      materialName: "qaldirgochlar_qoshigi",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qaldirgochlar_qoshigi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:8,
      materialName: "qonun_ustuvorligi_va_inson",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qonun_ustuvorligi_va_inson_manfaatlarini_taminlash__yurt_taraqqiyoti_va_xalq_farovonligining_garovi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:9,
      materialName: "sariq_devni_minib",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/sariq_devni_minib.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:10,
      materialName: "shajtanat",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shajtanat.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:11,
      materialName: "shovqin_erkin_azam_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shovqin_erkin_azam_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:12,
      materialName: "tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik__har_bir_rahbar_faoliyatining_kundalik_qoidasi_bolishi_kerak.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:13,
      materialName: "usmon_azim._sajlanma_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/usmon_azim._sajlanma_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:14,
      materialName: "xurshid_davron_bibixoni",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:15,
      materialName: "zulfiya_yana_bahor_hokim",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/zulfiya_yana_bahor_hokim.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:16,
      materialName: "yodgor",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yodgor.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:17,
      materialName: "yulduzli_tunlar",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yulduzli_tunlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:18,
      materialName: "zaxarli_hayot_yohud_ishq",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zaxarli_hayot_yohud_ishq__qurbonlari..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:19,
      materialName: "zhek_london_martin_iden",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zhek_london_martin_iden.pdf",
      roll: ['student'],
      categories: ['student']
    },
  ]
  const [arxivSoni,setArxivSoni]=useState(0)
  const soniMatirial=()=>{
    setArxivSoni(arxivSoni+1)
    console.log(arxivSoni);
    JSON.stringify(localStorage.setItem("Oqituvchi", arxivSoni))
  }
  console.log(arxivSoni);
  const [sardor, setSardor] = useState(Oqituvchi)
  return (
    <div>
      {
        sardor.map((item)=>{
          return <div className='kitob'>
          <Accordion className='Accordion'>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{ color: "black" }}
            >
              <Typography style={{display:"flex", justifyContent:"space-between"}}>{item.id} -- {item.materialName} <Link onClick={soniMatirial} to={item.file_name} style={{marginLeft:"600px",padding:'0',backgroundColor:"aqua",padding:"5px",textDecoration:'none'}} target="_blank" >Ko'rish</Link>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography style={{display:"flex"}}>
                 <h5 style={{color:"red"}}>Muallifi</h5>:  {item.author}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Link onClick={soniMatirial} to={item.file_name} className='havola' target="_blank" download>Ko'chirish</Link>
    
        </div>
        })
      }
    </div>
  );
}

export default BirinchiIkkinchi2;
